import React from 'react';
import { withTheme } from 'emotion-theming';
import { HoverAccentButton, Text } from '@lyearn-team/frontend-components';
import Draggable from '@lyearn-team/frontend-components/dist/Draggable/Draggable';
import { observer, inject } from 'mobx-react';
import * as s from './styles';

@withTheme
@inject(stores => ({ model: stores.liveClassModel }))
@observer
class Header extends React.Component {
  render() {
    const { theme, model } = this.props;
    const { hidePopup } = model.store.activity;
    return (
      <Draggable.Handle>
        <header className={s.activityHeader(theme)}>
          <Text.H4>Activity</Text.H4>
          <HoverAccentButton
            icon={{ type: 'close' }}
            onClick={hidePopup}
            className={s.closeButton}
          />
        </header>
      </Draggable.Handle>
    );
  }
}

export default Header;
